import {
    take,
    put,
    call,
    all,
    takeLatest,
    takeEvery,
} from 'redux-saga/effects';
import { positionActions as actions, notificationActions } from '../actions';
import { positionService } from '../services';

/* Add Position */
function* handleAddPositionRequest() {
    const action = yield take(actions.addPositionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(positionService.addPosition, dataParams)
        if (res.isError) {
            yield put(actions.addPositionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.addPositionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.addPositionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Get Department */
function* handleGetAllPositionRequest() {
    const action = yield take(actions.getAllPositionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(positionService.getAllPosition, dataParams);

        if (res.isError) {
            yield put(actions.getAllPositionError(res));

        } else {
            yield put(actions.getAllPositionSuccess(res));
        }

    } catch (error) {
        yield put(actions.getAllPositionError());
    }
}

/*  Get Position By Department Designation */
function* handleGetPositionByDepartmentDesignationRequest() {
    const action = yield take(actions.getPositionsByDepartmentDesignationRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(positionService.getPositionByDepartmentDesignation, dataParams);
        if (res.isError) {
            yield put(actions.getPositionsByDepartmentDesignationError(res));

        } else {
            yield put(actions.getPositionsByDepartmentDesignationSuccess(res));
        }

    } catch (error) {
        yield put(actions.getPositionsByDepartmentDesignationError());
    }
}

/* Update Position */
function* handleUpdatePositionRequest() {
    const action = yield take(actions.updatePositionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(positionService.updatePosition, dataParams);
        if (res.isError) {
            yield put(actions.updatePositionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.updatePositionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.updatePositionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}

/* Delete Position */
function* handleDeletePositionRequest() {
    const action = yield take(actions.deletePositionRequest.getType());
    const dataParams = action.payload;
    let res;
    try {
        res = yield call(positionService.deletePosition, dataParams);
        if (res.isError) {
            yield put(actions.deletePositionError(res));
            yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
        } else {
            yield put(actions.deletePositionSuccess(res));
            yield put(notificationActions.openSnackbar({ text: res?.message || res?.errorMessage, alertType: 'success' }));
        }
    } catch (error) {
        yield put(actions.deletePositionError());
        yield put(notificationActions.openSnackbar({ text: res?.errorMsg || res?.errorMessage, alertType: 'error' }));
    }
}


/* -----------Watchers-------------*/
function* handleAddPositionWatcher() {
    yield takeEvery(
        actions.addPositionRequest,
        handleAddPositionRequest,
    );
}

function* handleGetAllPositionWatcher() {
    yield takeEvery(
        actions.getAllPositionRequest,
        handleGetAllPositionRequest,
    );
}

function* handleGetPositionByDepartmentDesignationWatcher() {
    yield takeEvery(
        actions.getPositionsByDepartmentDesignationRequest,
        handleGetPositionByDepartmentDesignationRequest,
    );
}

function* handleUpdatePositionWatcher() {
    yield takeEvery(
        actions.updatePositionRequest,
        handleUpdatePositionRequest,
    );
}

function* handleDeletePositionWatcher() {
    yield takeEvery(
        actions.deletePositionRequest,
        handleDeletePositionRequest,
    );
}



function* rootPositionSaga() {
    yield all([
        handleAddPositionRequest(),
        handleAddPositionWatcher(),

        handleGetAllPositionRequest(),
        handleGetAllPositionWatcher(),

        handleGetPositionByDepartmentDesignationRequest(),
        handleGetPositionByDepartmentDesignationWatcher(),

        handleUpdatePositionRequest(),
        handleUpdatePositionWatcher(),

        handleDeletePositionRequest(),
        handleDeletePositionWatcher(),
    ]);
}

export default rootPositionSaga;
